import React, { useEffect } from 'react';
import { connect } from 'react-redux';

import Patient from './Patient';
import Doctor from './Doctor';
import { doctorsActionsTypes } from '../../redux/doctor/actions';
import { appointmentActionsTypes } from '../../redux/appointment/actions';
import { useStyles } from './style';
import { userActionsTypes } from '../../redux/user/actions';
import Assistant from './Assistant';
import Operator from './Operator';

function Appointments({
  session,
  doctorsInfo,
  appointmentsData,
  deleteMessages,
  getDoctorsInfo,
  createScheduleRequests,
  getScheduleRequests,
  getSchedulesByDate,
  getAppointments,
  clearAppointments,
  getUserData,
  getNewAccessToken,
  userState,
  setSelectedDoctor,
  clearSchedules,
  clearSelectedDoctor,
  getAppointmentsLight,
  getAppointmentsAll,
  getDoctorsInfoFromSpecialty,
  getMpPreference,
  getRapidQueues,
}) {
  const classes = useStyles();

  // It is set by default to the time zone of the server
  // moment.tz.setDefault('America/Montevideo');

  useEffect(() => {
    if (session) {
      getUserData(session.userType, session.id);
    }
    return () => {
      deleteMessages();
    };
  }, []);

  return (
    <>
      {session.userType === 'assistant' ? (
        <Assistant
          classes={classes}
          doctorsInfo={doctorsInfo}
          appointmentsData={appointmentsData}
          deleteMessages={deleteMessages}
          getDoctorsInfo={getDoctorsInfo}
          createScheduleRequests={createScheduleRequests}
          getScheduleRequests={getScheduleRequests}
          session={session}
          getSchedulesByDate={getSchedulesByDate}
          getAppointments={getAppointments}
          clearAppointments={clearAppointments}
          getUserData={getUserData}
          getNewAccessToken={getNewAccessToken}
          userState={userState}
          setSelectedDoctor={setSelectedDoctor}
          clearSchedules={clearSchedules}
          clearSelectedDoctor={clearSelectedDoctor}
        />
      ) : session.userType === 'doctor' ? (
        <Doctor
          classes={classes}
          doctorsInfo={doctorsInfo}
          appointmentsData={appointmentsData}
          deleteMessages={deleteMessages}
          getDoctorsInfo={getDoctorsInfo}
          createScheduleRequests={createScheduleRequests}
          getScheduleRequests={getScheduleRequests}
          doctor={session}
          getSchedulesByDate={getSchedulesByDate}
          getAppointments={getAppointmentsAll}
          clearAppointments={clearAppointments}
          getUserData={getUserData}
          getNewAccessToken={getNewAccessToken}
          userState={userState}
          getRapidQueues={getRapidQueues}
        />
      ) : session.userType === 'operator' ? (
        <Operator
          classes={classes}
          doctorsInfo={doctorsInfo}
          appointmentsData={appointmentsData}
          deleteMessages={deleteMessages}
          getDoctorsInfo={getDoctorsInfo}
          createScheduleRequests={createScheduleRequests}
          getScheduleRequests={getScheduleRequests}
          session={session}
          getSchedulesByDate={getSchedulesByDate}
          getAppointments={getAppointments}
          clearAppointments={clearAppointments}
          getUserData={getUserData}
          getNewAccessToken={getNewAccessToken}
          userState={userState}
          setSelectedDoctor={setSelectedDoctor}
          clearSchedules={clearSchedules}
          clearSelectedDoctor={clearSelectedDoctor}
          getDoctorsInfoFromSpecialty={getDoctorsInfoFromSpecialty}
        />
      ) : (
        <Patient
          classes={classes}
          doctorsInfo={doctorsInfo}
          appointmentsData={appointmentsData}
          deleteMessages={deleteMessages}
          getDoctorsInfo={getDoctorsInfo}
          createScheduleRequests={createScheduleRequests}
          getScheduleRequests={getScheduleRequests}
          patient={session}
          getAppointments={getAppointments}
          clearAppointments={clearAppointments}
          getUserData={getUserData}
          getNewAccessToken={getNewAccessToken}
          userState={userState}
          getMpPreference={getMpPreference}
        />
      )}
    </>
  );
}

const mapStateToProps = ({ session, doctors, appointments, user }) => {
  return {
    doctorsInfo: doctors, // doctors
    session,
    appointmentsData: appointments,
    userState: user, //userData
  };
};

const mapDispatchToProps = (dispatch) => ({
  getDoctorsInfo: (queryParams, queryValues) =>
    dispatch({
      type: doctorsActionsTypes.GET_DOCTORS,
      payload: { queryParams, queryValues },
    }),
  getScheduleRequests: (queryId) =>
    dispatch({
      type: appointmentActionsTypes.GET_SCHEDULE_REQUESTS,
      payload: { queryId },
    }),
  createScheduleRequests: (body, token) =>
    dispatch({
      type: appointmentActionsTypes.CREATE_SCHEDULE_REQUESTS,
      payload: { body, token },
    }),
  clearAppointments: () =>
    dispatch({ type: appointmentActionsTypes.CLEAR_APPOINTMENTS }),
  deleteMessages: () =>
    dispatch({
      type: appointmentActionsTypes.DELETE_MESSAGES,
    }),

  getAppointments: (userType, id, isDone, isPayed, queryParams, queryValues) =>
    dispatch({
      type: appointmentActionsTypes.GET_APPOINTMENTS, //TODO cambiar el formato de fechas en el back para no tener que hacer todo este juego con format
      payload: {
        userType,
        id,
        isDone,
        isPayed,
        queryParams,
        queryValues,
      },
    }),

  getAppointmentsLight: (
    userType,
    id,
    isDone,
    isPayed,
    queryParams,
    queryValues
  ) =>
    dispatch({
      type: appointmentActionsTypes.GET_APPOINTMENTS_LIGHT, //TODO cambiar el formato de fechas en el back para no tener que hacer todo este juego con format
      payload: {
        userType,
        id,
        isDone,
        queryParams,
        queryValues,
      },
    }),
  getAppointmentsAll: (
    userType,
    id,
    isDone,
    isPayed,
    queryParams,
    queryValues
  ) =>
    dispatch({
      type: appointmentActionsTypes.GET_APPOINTMENTS_ALL, //TODO cambiar el formato de fechas en el back para no tener que hacer todo este juego con format
      payload: {
        userType,
        id,
        isDone,
        isPayed,
        queryParams,
        queryValues,
      },
    }),

  getSchedulesByDate: (start, end, doctorId) =>
    dispatch({
      type: appointmentActionsTypes.GET_SCHEDULES_BY_DATE, //TODO cambiar el formato de fechas en el back para no tener que hacer todo este juego con format
      payload: {
        start,
        end,
        doctorId,
      },
    }),
  getUserData: (type, id) =>
    dispatch({ type: userActionsTypes.GET_USER, payload: { type, id } }),

  getDoctorsInfoFromSpecialty: (specialtyId) =>
    dispatch({
      type: doctorsActionsTypes.GET_DOCS_INFO_FROM_SPECIALTY,
      payload: { specialtyId },
    }),

  getNewAccessToken: (token) =>
    dispatch({
      type: userActionsTypes.REFRESH_TOKEN,
      payload: token,
    }),

  setSelectedDoctor: (doctorBody) =>
    dispatch({
      type: doctorsActionsTypes.SET_DOCTOR_BODY,
      payload: doctorBody,
    }),

  clearSchedules: () =>
    dispatch({ type: appointmentActionsTypes.CLEAR_SHEDULES }),

  clearSelectedDoctor: () =>
    dispatch({ type: doctorsActionsTypes.CLEAR_SELECT_DOCTOR }),

  getMpPreference: (body) =>
    dispatch({
      type: userActionsTypes.GET_USER_MP_PREFERENCE,
      payload: { body },
    }),

  getRapidQueues: () =>
    dispatch({ type: appointmentActionsTypes.GET_RAPID_QUEUES }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Appointments);
